const MediaListTypes = {
  GET_MEDIA_LIST_START: "GET_MEDIA_LIST_START",
  GET_MEDIA_LIST_SUCCESS: "GET_MEDIA_LIST_SUCCESS",
  GET_MEDIA_LIST_FAILED: "GET_MEDIA_LIST_FAILED",
  ADD_MEDIA_LIST_START: "ADD_MEDIA_LIST_START",
  ADD_MEDIA_LIST_SUCCESS: "ADD_MEDIA_LIST_SUCCESS",
};

export default MediaListTypes;
